export const omitProps = <
  T extends Record<PropertyKey, unknown>,
  PropKeys extends PropertyKey,
>(
  src: T,
  omittedPropKeys: readonly PropKeys[],
): Omit<T, PropKeys> => {
  const out: Partial<Omit<T, PropKeys>> = {}
  for (const key of Reflect.ownKeys(src)) {
    if ((omittedPropKeys as readonly PropertyKey[]).includes(key)) continue

    out[key] = src[key]
  }

  return out as Omit<T, PropKeys>
}
